module.exports = __webpack_public_path__ + "img/crc-04.60a25ff1.jpg";